import { validateEmail } from '../../../../utils/validator';

const validate = values => {
  const errors = {};
  if (!values.phoneNumber) {
    errors.phoneNumber = 'Champ requis';
  }
  if (!values.lastname) {
    errors.lastname = 'Champ requis';
  }
  if (!values.firstname) {
    errors.firstname = 'Champ requis';
  }
  if (!values.email) {
    errors.email = 'Champ requis';
  }
  if (values.email && !validateEmail(values.email)) {
    errors.email = 'Adresse email invalide';
  }
  return errors;
};

export default validate;
